import { addClassToIframe } from "./custom-component";

export const onRouteUpdate = () => {
  requestAnimationFrame(() => {
    addClassToIframe();
  });
};